import { useCallback } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import {
  channelTalkBootedState,
  channelTalkPendingOpenState,
} from "@/shared/store/channelTalkStore";

/**
 * 채널톡 상담창을 여는 함수를 돌려준다.
 *
 * boot 이 끝나기 전에는 showMessenger() 가 그냥 무시된다. 랜딩처럼 첫 진입 화면에서는
 * 그 사이에 누를 수 있으므로, 그때는 예약해 두고 boot 이 끝나면 useChannelTalkBoot 가 연다.
 */
export default function useOpenChannelTalk() {
  const isBooted = useRecoilValue(channelTalkBootedState);
  const setPendingOpen = useSetRecoilState(channelTalkPendingOpenState);

  return useCallback(() => {
    if (isBooted) {
      ChannelService.showMessenger();
    } else {
      setPendingOpen(true);
    }
  }, [isBooted, setPendingOpen]);
}
